import { Injectable } from '@angular/core';
import { NotificationService } from '../layout/notification.service';
import { GenericErrorHandlerService } from '../../core/services/generic-error-handler.service';
import { AccountService, SecurityService } from '../../api'
import { GenericRequestHandlerService } from '../../core/services/generic-request-handler.service';
import { LoadingService } from '../layout/loading.service';
import { UserService } from '../../core/services/user.service';

@Injectable({
    providedIn: 'root'
})
export class UserAccountsService {

    basePath = 'https://localhost/api';

    constructor(
        private loadingService: LoadingService,
        private notificationService: NotificationService,
        private genericErrorHandlerService: GenericErrorHandlerService,
        private genericRequestHandler: GenericRequestHandlerService,
        private api: AccountService,
        private userService: UserService,
        private securityService: SecurityService,
    ) {
    }

    public getProfile() {
        return this.securityService.currentUserQuery();
    }

    public changePassword = (content) => {
        return this.genericRequestHandler.callRequest(
            this.api.changePasswordHandler(this.userService.user.id, content),
            'Hasło zostało zmienione'
        );
    }

    public editProfile = (content) => {
        return this.genericRequestHandler.callRequest(
            this.api.editProfileHandler(content),
            'Profil został zapisany'
        );
    }

}
